import React from 'react';
import { Clock, AlertCircle, ChevronRight } from 'lucide-react';
import { mockCandidates } from '../../utils/mockData';
import { Candidate } from '../../types/hr.types';
interface FollowUpsWidgetProps {
  type: 'today' | 'overdue';
  onCandidateClick?: (candidate: Candidate) => void;
}
export function FollowUpsWidget({
  type,
  onCandidateClick
}: FollowUpsWidgetProps) {
  const today = new Date().toISOString().split('T')[0];
  const candidates = mockCandidates.filter(c => {
    if (!c.followUpDate) return false;
    const isToday = c.followUpDate === today;
    const isOverdue = c.followUpDate < today;
    return type === 'today' ? isToday : isOverdue;
  });
  const title = type === 'today' ? "Today's Follow-ups" : 'Overdue Follow-ups';
  const icon = type === 'today' ? <Clock className="h-5 w-5 text-blue-500" data-id="element-1514" /> : <AlertCircle className="h-5 w-5 text-red-500" data-id="element-1515" />;
  const bgClass = type === 'today' ? 'bg-blue-50/50' : 'bg-red-50/50';
  const iconBgClass = type === 'today' ? 'bg-blue-100' : 'bg-red-100';
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col h-full" data-id="element-1516">
      <div className={`px-4 py-3 border-b border-gray-100 flex items-center justify-between ${bgClass}`} data-id="element-1517">
        <div className="flex items-center gap-2" data-id="element-1518">
          <div className={`p-1.5 rounded-lg ${iconBgClass}`} data-id="element-1519">{icon}</div>
          <h3 className="font-semibold text-gray-900" data-id="element-1520">{title}</h3>
        </div>
        <span className="bg-white text-gray-700 text-xs font-bold px-2.5 py-1 rounded-full shadow-sm border border-gray-100" data-id="element-1521">
          {candidates.length}
        </span>
      </div>
      <div className="p-4 flex-1 overflow-y-auto" data-id="element-1522">
        {candidates.length > 0 ? <div className="space-y-3" data-id="element-1523">
            {candidates.map(candidate => <div key={candidate.id} onClick={() => onCandidateClick?.(candidate)} className="group relative flex items-center justify-between p-3 rounded-xl bg-white border border-gray-100 shadow-sm hover:shadow-md hover:border-blue-100 transition-all duration-200 cursor-pointer" data-id="element-1524">
                <div className="flex items-center gap-3 min-w-0" data-id="element-1525">
                  <div className="h-10 w-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 font-medium border border-gray-200 flex-shrink-0" data-id="element-1526">
                    {candidate.firstName[0]}
                    {candidate.lastName[0]}
                  </div>
                  <div className="min-w-0" data-id="element-1527">
                    <p className="text-sm font-semibold text-gray-900 truncate group-hover:text-blue-700 transition-colors" data-id="element-1528">
                      {candidate.firstName} {candidate.lastName}
                    </p>
                    <p className="text-xs text-gray-500 truncate" data-id="element-1529">
                      {candidate.followUpReason || 'No reason provided'}
                    </p>
                  </div>
                </div>
                <ChevronRight className="h-4 w-4 text-gray-400 group-hover:text-blue-600 transition-colors flex-shrink-0" data-id="element-1530" />
              </div>)}
          </div> : <div className="h-full flex flex-col items-center justify-center text-center py-6" data-id="element-1531">
            <div className="h-12 w-12 rounded-full bg-gray-50 flex items-center justify-center mb-3" data-id="element-1532">
              <Clock className="h-6 w-6 text-gray-400" data-id="element-1533" />
            </div>
            <p className="text-sm font-medium text-gray-900" data-id="element-1534">All caught up!</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1535">
              No {type} follow-ups pending.
            </p>
          </div>}
      </div>
    </div>;
}